module.exports = __webpack_public_path__ + "static/media/presentation.3c195dbe.jpg";